import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

export default function NotificationSkeleton() {
  return (
    <SkeletonTheme baseColor="#202020" highlightColor="#444">
      <div className="borderBottomNotificationDropdown">
        <div className="d-flex justify-content-between m-2">
          <div className="d-flex">
            <Skeleton height={55} width={55} circle={true} />

            <div className="text-white ms-1 profileName">
              <div className="text-decoration-none">
                <div className="link-open px-2 py-2">
                  <Skeleton width={180} height={15} />
                  <Skeleton width={200} height={10} />
                </div>
              </div>
            </div>
          </div>
          <div className="timeStampColor"></div>
        </div>
      </div>
    </SkeletonTheme>
  );
}
